import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LocalizedTimeRangeFormatPipe } from '@wilson/localization';
import { ActivityCategorySelectionComponent } from './activity-category-selection/activity-category-selection.component';
import { ActivityCategoryConfirmModalComponent } from './activity-category-selection/activity-category-confirm-modal/activity-category-confirm-modal.component';
import { NzFormModule } from 'ng-zorro-antd/form';
import { NzSelectModule } from 'ng-zorro-antd/select';
import { TranslateModule } from '@ngx-translate/core';
import { FormsModule } from '@angular/forms';
import { CompanySettingsService } from './company-settings.service';
import { ShiftTimePreferenceSettingLabelPipe } from './shift-time-preference-setting-label.pipe';
import { NzButtonModule } from 'ng-zorro-antd/button';
import { AuthorizationModule } from '@wilson/authorization';
import { NzTooltipModule } from 'ng-zorro-antd/tooltip';
import { NzAlertModule } from 'ng-zorro-antd/alert';
import { NzModalModule } from 'ng-zorro-antd/modal';
import { TranslateActivityCategoryPipeModule } from '@wilson/activity-categories/data';

@NgModule({
  imports: [
    CommonModule,
    NzFormModule,
    FormsModule,
    NzSelectModule,
    TranslateModule.forChild(),
    NzButtonModule,
    AuthorizationModule,
    NzTooltipModule,
    LocalizedTimeRangeFormatPipe,
    NzAlertModule,
    NzModalModule,
    TranslateActivityCategoryPipeModule,
  ],
  declarations: [
    ActivityCategorySelectionComponent,
    ActivityCategoryConfirmModalComponent,
    ShiftTimePreferenceSettingLabelPipe,
  ],
  exports: [
    ActivityCategorySelectionComponent,
    ShiftTimePreferenceSettingLabelPipe,
  ],
  providers: [CompanySettingsService],
})
export class CompanySettingsCoreModule {}
